/**
 * Header - App navigation using Simulacra design system
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { XStack, Text } from 'tamagui';
import { MatrixButton } from './base';

interface HeaderProps {
  isLoggedIn: boolean;
  userEmail?: string;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ isLoggedIn, userEmail, onLogout }) => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <XStack
      backgroundColor="$backgroundPress"
      borderBottomWidth={1}
      borderBottomColor="$borderColor"
      paddingVertical="$3"
      paddingHorizontal="$4"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gap="$3"
      $sm={{
        paddingHorizontal: '$3',
        paddingVertical: '$2',
      }}
    >
      {/* Left side - Logo and Nav */}
      <XStack alignItems="center" gap="$4" flexWrap="wrap">
        <Link to="/" style={{ textDecoration: 'none' }}>
          <Text
            fontFamily="$heading"
            fontSize="$6"
            fontWeight="bold"
            color="$green10"
            letterSpacing={1}
          >
            NINGS
          </Text>
        </Link>

        <XStack gap="$3" flexWrap="wrap" $sm={{ gap: '$2' }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Text
              fontFamily="$body"
              fontSize="$3"
              color={isActive('/') ? '$green10' : '$color'}
              hoverStyle={{ color: '$green10' }}
              cursor="pointer"
            >
              Home
            </Text>
          </Link>
          <Link to="/discover" style={{ textDecoration: 'none' }}>
            <Text
              fontFamily="$body"
              fontSize="$3"
              color={isActive('/discover') ? '$green10' : '$color'}
              hoverStyle={{ color: '$green10' }}
              cursor="pointer"
            >
              Discover
            </Text>
          </Link>
          <Link to="/chat" style={{ textDecoration: 'none' }}>
            <Text
              fontFamily="$body"
              fontSize="$3"
              color={isActive('/chat') ? '$green10' : '$color'}
              hoverStyle={{ color: '$green10' }}
              cursor="pointer"
            >
              Chat
            </Text>
          </Link>
          {isLoggedIn && (
            <Link to="/settings" style={{ textDecoration: 'none' }}>
              <Text
                fontFamily="$body"
                fontSize="$3"
                color={isActive('/settings') ? '$green10' : '$color'}
                hoverStyle={{ color: '$green10' }}
                cursor="pointer"
              >
                Settings
              </Text>
            </Link>
          )}
        </XStack>
      </XStack>

      {/* Right side - User info */}
      <XStack alignItems="center" gap="$3">
        {isLoggedIn ? (
          <>
            <Text
              fontFamily="$mono"
              fontSize="$2"
              color="$colorPress"
              $sm={{ display: 'none' }}
            >
              {userEmail}
            </Text>
            <MatrixButton variant="secondary" size="$2" onPress={onLogout}>
              Logout
            </MatrixButton>
          </>
        ) : (
          <Link to="/login" style={{ textDecoration: 'none' }}>
            <MatrixButton variant="primary" size="$2">
              Login / Sign Up
            </MatrixButton>
          </Link>
        )}
      </XStack>
    </XStack>
  );
};

export default Header;
